import * as Yup from 'yup';

export class AttributeValidation {
    static create = Yup.object().shape({
        attributeAutoIncrement: Yup.string().required("Please Select a Value"),
        attributeDataType: Yup.string().required("Attribute DataType Is Required."),
        attributeDecimalLimit: Yup.string().required("Attribute Decimal Limit Is Required"),
        attributeDefaultValue: Yup.string().required("Please Select a Value"),
        attributeForeignKey: Yup.string().required("Please Select a Value"),
        attributeIsRequiredCreate: Yup.string().required("Please Select a Value"),
        attributeIsRequiredDelete: Yup.string().required("Please Select a Value"),
        attributeIsRequiredUpdate: Yup.string().required("Please Select a Value"),
        attributeLength: Yup.string().required("Attribute Length Is Required."),
        attributeName: Yup.string().required("Attribute Name Is Required"),
        attributeNull: Yup.string().required("Please Select a Value"),
        attributePrimaryKey: Yup.string().required("Please Select a Value"),
        // attributeReferenceAttribute: Yup.string().required("Please Select a Value"),
        attributeReferenceEntity: Yup.string().required("Please Select a Value"),
        attributeStartValue: Yup.string().required("Attribute Start Value is required"),
        attributeTestData: Yup.string().required("Attribute Test Data is required"),
        attributeUnique: Yup.string().required("Please Select a Value"),
    })
}